import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
} from "@progress/kendo-react-grid";
import Headline5 from '../headings/Headline5';
import Button from '../button';
import { Icon } from "@iconify/react";


function CheckHistoryTable(Props: any) {

    const requestEmail = (props: GridCellProps) => {
        return (
            <td className="break-all">
                {props.dataItem.requested_to_email}
            </td>
        )
    }

    const statusCell = (props: GridCellProps) => {
        return (
            <td>
                 <div className="ratingStatus pending">
                {props.dataItem.request_status}
                </div>
            </td>
        )
    }
    
    const requestDate = (props: GridCellProps) => {
        return (
            <td>
                {(new Date(parseInt(props.dataItem.requested_on))).toDateString().slice(3)}
            </td>
        )
    }

    const reminderCell = (props: GridCellProps) => {

        
        return (
            <td>
                {
                    props.dataItem.request_status === 'Pending' &&
                    <button type="button" className="link-btn" onClick={() => Props.sendReminder(props.dataItem.assessment_request_id)} >Send Reminder</button>
                }
            </td>
        )
    }
 
    const resentDate = (props: GridCellProps) => {
       
        return (
            <td>
                {props && props.dataItem && props.dataItem.resent_on ? new Date(parseInt(props.dataItem.resent_on)).toDateString().slice(3) : '' }
            </td>
        )
   }

    return (
      
        <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
             <Grid
                data={Props.data}
            >
                <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
                <Column field="requested_to_email" cell={requestEmail} title="Requested To" width='150px' />
                <Column field="company_name" title="Company" width='80px' />
                <Column field="candidate_role" title="Candidate Role" width='120px'/>
                <Column field="requested_on" title="Requested on" cell={requestDate} width='100px'/>
                <Column field="request_status" title="Status" cell={statusCell} />
                <Column field="resent_on" title="Resent on" width='80px' cell={resentDate} />
                <Column cell={reminderCell} />
            </Grid>
    </div>
  )
}

export default CheckHistoryTable